export const reduceBusinessObjectiveResponse = ({
  data,
  state
}) => {
  const newBOs = data.reduce((acc, BO) => {
    const {
      productApiName
    } = BO;
    return Object.assign({}, acc, {
      [productApiName]: BO
    });
  }, {});
  return Object.assign({}, state, {}, newBOs);
};